import merge from 'lodash/merge'

export default ({ fillColor }) => {

  let jss = {
    '& svg': {
      fill: fillColor
    },
  }

  return jss
}
